export default {
  header: {
    notes: 'Welcome message on start page',
    message: 'Hi {{firstName}} {{lastName}}, welcome to SAM!',
  },
};
